import { Capacitor } from "@capacitor/core";
import { useEffect, useState, useRef, useContext } from "react";
import { ROUTE_PAGE_CUSTOMER_APPLICATIONS } from "../../../customers/routes/routes";
import { useWizard } from "../../LoanApplicationContext";
import { withPermissionHOC } from "../../../permission/components/permissionHOC/permissionHOC";
import { mapingStructuredDataQuestion } from "../../actions/actions"
import WizardSidebar from '../../components/wizardSidebar';
import FormSection from '../../components/form';
import ErrorDashboard from '../../components/errorDashboard';
import { Box, Grid, Button, Typography, useMediaQuery, useTheme } from "@mui/material";
import { useParams, Link, useHistory, Link as RouterLink } from "react-router-dom";
import HelpCircleIcon from "../../../../assets/images/icons/buttonsIcons/helpCircleIcon";
import Return from "../../../../assets/images/icons/buttonsIcons/return";
import Delete from "../../../../assets/images/icons/buttonsIcons/delete";
import Copy from "../../../../assets/images/icons/buttonsIcons/copy";
import Save from "../../../../assets/images/icons/buttonsIcons/save";
import CheckSubmit from "../../../../assets/images/icons/buttonsIcons/checkSubmit";
import Arrow from "../../../../assets/images/icons/buttonsIcons/arrow";
import ClickAwayListener from '@mui/material/ClickAwayListener';
import Grow from '@mui/material/Grow';
import Paper from '@mui/material/Paper';
import Popper from '@mui/material/Popper';
import MenuItem from '@mui/material/MenuItem';
import MenuList from '@mui/material/MenuList';
import ButtonGroup from '@mui/material/ButtonGroup';
import { useTranslation } from "react-i18next";
import { LOANS_APPLICATION } from "../../locales/namespaces";
import { ROUTE_PAGE_HOME } from "../../../../routers/routes";
import { ROUTE_PAGE_LOANS_INDEX } from "../../../loans/routes/routes";
import { getRouteUrl } from "../../../../helpers/getRouteUrl";
import SupportDialog from "../../../../pages/supportDialog/supportDialog";
import CopyLoanPopup from "../../components/copyLoanPopup";
import ProgressBar from "../../components/progressBar";
import Pagination from "../../components/pagination";
import { showPopup } from '../../../../components/globalPopup/globalPopupService';
import * as yup from "yup";
import { ConfigContext } from '../../../../theme/mantis/contexts/configContext';
import ContentLoader from "../../../../components/contentLoader/contentLoader";
import useUserData from "../../../../hooks/user/useUserData";
import { GLOBAL_VARS } from "../../../../App";
import { useSelector } from "react-redux";

const Index = () => {
	
	const { getStructureData, submitForm } = useWizard();
	const { id } = useParams();
	const theme = useTheme();
	const matchBetweenXSSM = useMediaQuery('@media (min-width:0px) and (max-width:938px)');
	const matchDownMD = useMediaQuery((theme) => theme.breakpoints.down('md'));
	const { t } = useTranslation(LOANS_APPLICATION)
	const anchorRef = useRef(null);
	const [anchorMobile, setAnchorMobile] = useState(null);
	const [open, setOpen] = useState(false);
	const [selectedIndex, setSelectedIndex] = useState(0);
	const [formErrors, setFormErrors] = useState(null);
	const [formFields, setFormFields] = useState([])
	const [activeIndex, setActiveIndex] = useState(0);
	const [popoverState, setPopoverState] = useState({});
	const [activeIndexSubItem, setActiveIndexSubItem] = useState(0);
	const [totalNumberFieldsRequired, setTotalNumberFieldsRequired] = useState(0);
	const [openCopyLoanPopup, setOpenCopyLoanPopup] = useState(false)
	const [loading, setLoading] = useState(false)
	const [relatedApps, setRelatedApps] = useState([])
	const { onResetCountdown } = useContext(ConfigContext);
	const [initialStructureData, setInitialStructureData] = useState([])
	const [didCopyLoan, setDidCopyLoan] = useState(false);
	const history = useHistory();
	const [hasUnsavedChanges, setHasUnsavedChanges] = useState(false);
	const [showModal, setShowModal] = useState(false);
	const lastLocation = useRef(null);
	const unblockRef = useRef(null);
	const [hasInitialized, setHasInitialized] = useState(false);
	const { language } = useUserData()
	const user = useSelector((state) => state.currentUser);
	const custId = user.toJS().data.customerId
	const buttons = [
		{ label: t('Save') },
		{ label: t("Return") },
		{ label: t('Help') },
		{ label: t('Reset') },
		{ label: t('Copy') },
	];
	
	const handleMenuItemClick = (event, index) => {
		onResetCountdown();
		setAnchorMobile(anchorMobile ? null : event.currentTarget);
		setSelectedIndex(index);
		const menuActions = [
			() => saveForm(),
			() => history.push(getRouteUrl(custId ? ROUTE_PAGE_LOANS_INDEX : ROUTE_PAGE_CUSTOMER_APPLICATIONS)),
			() => setPopoverState(firstFieldPopover),
			() => handleResetForm(),
			() => setOpenCopyLoanPopup(true),
		];
		if (menuActions[index]) {
			menuActions[index]();
		}
		setOpen(false);
	};
	
	const handleResetForm = () => {
		const resetValuesInFormFields = (originalFields) => {
			const excludeDescriptionsNotSubgroup = ["Τύπος αίτησης", "Σκοπός δανείου", "Χρήση ακινήτου"];
			const excludeDescriptionsSubgroup = ["Τύπος Ενεχόμενου"];
			const clonedFields = structuredClone(originalFields);
			return clonedFields.map(section => {
				if (section.questions.subgroups.length === 0) {
					section.questions.questions.forEach(q => {
						if (!excludeDescriptionsNotSubgroup.includes(q.DescriptionEL)) {
							q.Value = '';
						}
					});
				} else {
					section.questions.subgroups.forEach(sub => {
						sub.questions.forEach(q => {
							if (!excludeDescriptionsSubgroup.includes(q.DescriptionEL)) {
								q.Value = '';
							}
						});
					});
				}
				return section;
			});
		};
		setFormFields(resetValuesInFormFields(formFields));
		setFormErrors(null)
		setTotalNumberFieldsRequired(0)
	}
	
	const allQuestionsInOneArray = (data) => {
		const formFields = data.map(f => f.questions)
		let allQuestions = [];
		const subgroups = (questionsArray) => {
			questionsArray?.forEach(q => {
				if (q?.questions?.length > 0) {
					allQuestions = [...allQuestions, ...q?.questions]
				} else {
					allQuestions.push(q)
				}
			});
		};
		formFields.forEach(field => {
			field?.subgroups?.length > 0 ? subgroups(field?.subgroups) : subgroups(field?.questions)
		});
		return allQuestions;
	};
	
	const saveForm = async (isFinal) => {
		const validate = isFinal ? await validationFields() : false
		if (!isFinal) {
			setFormErrors(null)
			setTotalNumberFieldsRequired(0)
		}
		setLoading(true)
		if (validate) {
			showPopup({
				title: '',
				message: t("Not all required fields have been filled in or a field contains an invalid value"),
				onConfirm: () => {
				}
			})
		}
		if (!validate) {
			submitForm({
				loanId: id,
				isFinal: isFinal,
				data: allQuestionsInOneArray(formFields),
				onSuccess: (data) => {
					setLoading(false)
					setHasUnsavedChanges(false);
					if (isFinal === 1) {
						history.push(getRouteUrl(custId ? ROUTE_PAGE_LOANS_INDEX : ROUTE_PAGE_CUSTOMER_APPLICATIONS))
					}
				},
				onError: (data) => {
					setLoading(false)
				},
			});
		} else {
			setLoading(false)
		}
	}
	
	const validationFields = async () => {
		const allQuestions = allQuestionsInOneArray(formFields).flat();
		const getQuestionKey = (field) =>
			`${field.QuestionId}_${field.GroupId}_${field.GroupRepeatNum}`;
		
		const initialValues = {};
		const validationFields = {};
		
		allQuestions.forEach((field, index) => {
			const key = getQuestionKey(field, index);
			initialValues[key] = (field.Value || field?.CustomValue )?? '';
			
			let validator;
			
			switch (field.Type) {
				case 'text':
				case 'list':
					validator = yup.string();
					break;
				case 'email':
					validator = yup.string().email(t("Invalid email"));
					break;
				case 'number':
					validator = yup
					.number()
					.typeError(t("Must be a number"));
					break;
				case 'date':
					validator = yup.string();
					break;
				default:
					validator = yup.string();
			}
			
			if (field.required) {
				validator = validator.required(t("Required"));
			}
			
			if (field.RegExpr) {
				const match = field.RegExpr.match(/^\/(.*)\/([gimsuy]*)?$/);
				if (match) {
					const [, pattern, flags] = match;
					try {
						const regex = new RegExp(pattern, flags);
						validator = validator.matches(
							regex,
							language === 'en'
								? (field.RegExprENMessage || t("Invalid format"))
								: (field.RegExprELMessage || t("Invalid format"))
						);
					} catch (e) {
						console.warn(`Invalid RegExpr for field ${key}:`, field.RegExpr);
					}
				}
			}
			
			validationFields[key] = validator;
		});
		
		setTotalNumberFieldsRequired(allQuestions.filter(item => item.required)?.length);
		
		const validationSchema = yup.object().shape(validationFields);
		
		try {
			await validationSchema.validate(initialValues, { abortEarly: false });
			setFormErrors({});
			return false;
		} catch (err) {
			if (err.inner) {
				const errors = {};
				err.inner.forEach(validationError => {
					errors[validationError.path] = validationError.message;
				});
				setFormErrors(errors);
				return true;
			}
		}
	};
	
	const updateFormFields = (data, isDifferentValue) => {
		
		setFormFields(data);
		if (isDifferentValue) {
			setHasUnsavedChanges(true);
		}
		validationFields()
	}
	const handleClickMobile = (event) => {
		setAnchorMobile(event.currentTarget);
		setOpen((prevOpen) => !prevOpen);
	};
	
	const getData = async (oldData) => {
		setLoading(true)
		getStructureData({
			loanId: id,
			onSuccess: (data) => {
				const structuredOutput = mapingStructuredDataQuestion(data?.data);
				const transformedToArray = Object.entries(structuredOutput).map(([key, questions]) => ({
					category: key,
					questions
				}));
				setFormFields(transformedToArray)
				setLoading(false)
				setRelatedApps(data.RelatedApps)
				setInitialStructureData(data?.data)
			},
			onError: (data) => {
				setLoading(false)
			},
		});
	};
	
	const copyLoan = (copyLoanData) => {
		const updatedStructure = {
			...initialStructureData,
			GroupQuestions: copyLoanData.GroupQuestions
		};
		const structuredOutput = mapingStructuredDataQuestion(updatedStructure);
		const transformedToArray = Object.entries(structuredOutput).map(([key, questions]) => ({
			category: key,
			questions
		}));
		setFormFields(transformedToArray)
		setOpenCopyLoanPopup(false);
		setLoading(false);
		setFormErrors(null)
		setTotalNumberFieldsRequired(0)
		setDidCopyLoan(true);
		setHasUnsavedChanges(false);
	};
	
	const firstFieldPopover = () => {
		let popover = (formFields[activeIndex].questions.subgroups.length > 0 ? formFields[activeIndex].questions.subgroups[activeIndexSubItem].questions[0].DescriptionEL : formFields[activeIndex].questions.questions[0].DescriptionEL)
		
		return { [popover + '']: [popover + ''] }
	}
	
	useEffect(() => {
		GLOBAL_VARS.hasDigitalFormChanged = hasUnsavedChanges;
	}, [hasUnsavedChanges]);
	
	useEffect(() => {
		if (didCopyLoan) {
			setDidCopyLoan(false);
		}
	}, [didCopyLoan]);
	
	useEffect(() => {
		getData();
	}, []);
	useEffect(() => {
		if (!hasInitialized && formFields.length > 0) {


			console.log(formFields);


			validationFields()
			setHasInitialized(true);
		}

	}, [formFields, hasInitialized]);
	
	useEffect(() => {
		const timer = setTimeout(() => {
			if (formFields.length > 0) {
				validationFields();
			}
			onResetCountdown();
		}, 500);
		
		return () => clearTimeout(timer);
	}, [activeIndex, activeIndexSubItem]);
	
	useEffect(() => {
		unblockRef.current = history.block((tx) => {
			if (hasUnsavedChanges) {
				setShowModal(true);
				lastLocation.current = tx;
				showPopup({
					title: '',
					message: t('Warning') + ': ' + t('You have unsaved changes. Are you sure you want to close the form and lose your modifications?'),
					cancel: t('Cancel'),
					ok: t('Close without saving'),
					onConfirm: () => {
						if (unblockRef.current) unblockRef.current();
						if (lastLocation.current) {
							history.push(lastLocation.current.pathname);
						}
					}
				});
				
				return false;
			}
		});
		return () => {
			if (unblockRef.current) unblockRef.current();
		};
	}, [hasUnsavedChanges, history]);
	
	return (
		<Box className="loans-application">
			<Box sx={{ padding: { xs: '0 0', sm: '0 0', md: '38px 20px !important' } }} className="application-page">
				<Grid container spacing={0}>
					<Grid item xs={12} sm={12} md={4} lg={3}>
						<Box sx={{ marginRight: { xs: '0', sm: '0', md: '20px', } }}>
							<WizardSidebar
								className={matchDownMD ? 'mobile-wizard-sidebar' : ''}
								formFields={formFields}
								activeIndex={activeIndex}
								activeIndexSubItem={activeIndexSubItem}
								setActiveIndexSubItem={setActiveIndexSubItem}
								formErrors={formErrors}
								setActiveIndex={setActiveIndex}
								allQuestionsInOneArray={allQuestionsInOneArray(formFields)}
							/>
							{!matchDownMD && <ErrorDashboard/>}
						</Box>
					</Grid>
					<Grid item xs={12} sm={12} md={8} lg={9}>
						<ProgressBar activeStep={Object.keys(formErrors || {})?.length}
									 totalSteps={totalNumberFieldsRequired}/>
						<FormSection
							formFields={formFields}
							activeIndex={activeIndex}
							activeIndexSubItem={activeIndexSubItem}
							popoverState={popoverState}
							setPopoverState={setPopoverState}
							setFormFields={(data, isDifferentValue) => updateFormFields(data, isDifferentValue)}
							formErrors={formErrors}
							setFormErrors={setFormErrors}
							totalNumberFieldsRequired={totalNumberFieldsRequired}
						/>
						<Box className="flex-center">
							<Pagination
								min={0}
								max={formFields.length - 1}
								formFields={formFields}
								active={activeIndex}
								activeIndexSubItem={activeIndexSubItem}
								onChange={(index, subIndex) => {
									setActiveIndex(index);
									setActiveIndexSubItem(subIndex);
									window.scrollTo({ top: 0, behavior: 'smooth' });
								}}
							/>
						</Box>
					</Grid>
				</Grid>
			</Box>
			
			<CopyLoanPopup
				open={openCopyLoanPopup}
				isCurrentLoan={id}
				onCopy={(e) => {
					copyLoan(e)
				}}
				relatedApps={relatedApps}
				onClose={() => {
					setOpenCopyLoanPopup(false)
				}}
			/>
			<Box sx={{
				backgroundColor: '#fff',
				position: 'fixed',
				bottom: '0',
				left: '0',
				right: '0',
				zIndex: '100',
				boxShadow: '1px 1px 1px 1px #CAD1E5',
				padding: { xs: '16px 8px', sm: '16px 24px', md: '16px 24px' }
			}}>
				<Box sx={{ ...(Capacitor.isNativePlatform() ? { marginBottom: 4 } : {}) }}>
					<Grid container alignItems="center" justifyContent="space-between">
						<Grid item xs={12} sm={12} md={12} lg={12}>
							<div style={{ display: 'flex', justifyContent: 'flex-end' }}>
								<Grid container spacing={1} justifyContent="flex-end">
									<Grid item sx={{
										display: 'flex',
										width: {
											xs: '100%',
											sm: '100%',
											md: 'unset',
											[theme.breakpoints.up(939)]: 'unset',
										}
									}}
									>
										{matchBetweenXSSM ?
											<>
												<ButtonGroup
													variant="outlined"
													ref={anchorRef}
													sx={{
														'button, a': {
															padding: { xs: '8px 8px' },
															'&:hover': {
																borderColor: '#cdcdcd',
															},
														}
													}}
												>
													<Button
														size={'small'}
														variant={'outlined'}
														sx={{ gap: '8px', minWidth: '150px' }}
														id="help-button"
														component={RouterLink}
														to={getRouteUrl(custId ? ROUTE_PAGE_LOANS_INDEX : ROUTE_PAGE_CUSTOMER_APPLICATIONS)}
													>
														<Return/>
													</Button>
													
													<Button size={'small'} variant={'outlined'}
															onClick={handleClickMobile}
															sx={{ padding: '8px', minWidth: { sm: '28px' } }}>
														<Arrow/>
													</Button>
													<Popper
														sx={{ zIndex: 1 }}
														open={open}
														anchorEl={anchorMobile}
														disablePortal
														role={undefined}
														transition
													>
														{({ TransitionProps, placement }) => (
															<Grow
																{...TransitionProps}
																style={{
																	transformOrigin:
																		placement === 'bottom' ? 'center top' : 'center bottom',
																}}
															>
																<Paper>
																	<ClickAwayListener
																		onClickAway={() => setOpen(false)}>
																		<MenuList id="split-button-menu" autoFocusItem>
																			{buttons.map((option, index) => (
																				<MenuItem
																					key={option.label}
																					disabled={index === selectedIndex || (relatedApps.length === 0 && index === 4)}
																					selected={index === selectedIndex}
																					onClick={(event) => handleMenuItemClick(event, index)}
																				>
																					{option.label}
																				</MenuItem>
																			))}
																		</MenuList>
																	</ClickAwayListener>
																</Paper>
															</Grow>
														)}
													</Popper>
													
													{selectedIndex === 0 && (
														<Button
															disabled={loading}
															size={"small"}
															variant={"outlined"}
															sx={{
																gap: '8px', minWidth: '150px', '&.Mui-disabled': {
																	borderRadius: '8px',
																	borderTopLeftRadius: '0',
																	borderBottomLeftRadius: '0',
																}
															}}
															onClick={(event) => {
																event.stopPropagation()
																saveForm()
															}}
														>
															<Save/> {t('Save')}
														</Button>
													)}
													
													{selectedIndex === 1 && (
														<Button
															size={'small'}
															variant={'outlined'}
															sx={{ gap: '8px', minWidth: '150px' }}
															id="help-button"
															component={RouterLink}
															to={getRouteUrl(custId ? ROUTE_PAGE_LOANS_INDEX : ROUTE_PAGE_CUSTOMER_APPLICATIONS)}
														>
															<Return/> {t("Return")}
														</Button>
													)}
													
													{selectedIndex === 2 && (
														<Button
															size={'small'}
															variant={'outlined'}
															sx={{ gap: '8px', minWidth: '150px' }}
															id="help-button"
															onClick={(event) => {
																event.stopPropagation();
																setPopoverState(firstFieldPopover)
																
															}}
														>
															<HelpCircleIcon/>{t('Help')}
														</Button>
													)}
													
													{selectedIndex === 3 && (
														<Button
															size={"small"}
															variant={"outlined"}
															sx={{ gap: '8px', minWidth: '150px' }}
															onClick={(event) => {
																event.stopPropagation()
																handleResetForm()
															}}
														>
															<Delete/> {t('Reset')}
														</Button>
													)}
													
													{selectedIndex === 4 && (
														<Button
															disabled={relatedApps.length === 0}
															size={"small"}
															variant={"outlined"}
															onClick={(event) => {
																event.stopPropagation()
																setOpenCopyLoanPopup(true)
															}}
															sx={{
																gap: '8px', minWidth: '150px', '&.Mui-disabled': {
																	borderRadius: '8px',
																	borderTopLeftRadius: '0',
																	borderBottomLeftRadius: '0',
																}
															}}
														>
															<Copy/> {t('Copy')}
														</Button>
													)}
												</ButtonGroup>
											
											</>
											:
											<>
												<ButtonGroup variant="outlined" aria-label="Basic button group"
															 sx={{
																 'button, a': {
																	 '&:hover': {
																		 borderColor: '#cdcdcd',
																	 },
																 }
															 }}>
													<Button
														size={'small'}
														variant={'outlined'}
														sx={{ gap: '8px', minWidth: '150px' }}
														id="help-button"
														component={RouterLink}
														to={getRouteUrl(custId ? ROUTE_PAGE_LOANS_INDEX : ROUTE_PAGE_CUSTOMER_APPLICATIONS)}
													>
														<Return/> {t("Return")}
													</Button>
													<Button
														size={'small'}
														variant={'outlined'}
														sx={{ gap: '8px', minWidth: '150px' }}
														id="help-button"
														onClick={(event) => {
															event.stopPropagation();
															setPopoverState(firstFieldPopover)
															
														}}
													>
														<HelpCircleIcon/>{t('Help')}
													</Button>
													
													<Button
														size={"small"}
														variant={"outlined"}
														sx={{ gap: '8px', minWidth: '150px' }}
														onClick={(event) => {
															event.stopPropagation()
															handleResetForm()
														}}
													>
														<Delete/> {t('Reset')}
													</Button>
													
													<Button
														disabled={relatedApps.length === 0}
														size={"small"}
														variant={"outlined"}
														onClick={(event) => {
															event.stopPropagation()
															setOpenCopyLoanPopup(true)
														}}
														sx={{
															gap: '8px', minWidth: '150px', '&.Mui-disabled': {
																borderRadius: '0',
															}
														}}
													>
														<Copy/> {t('Copy')}
													</Button>
													
													<Button
														disabled={loading}
														size={"small"}
														variant={"outlined"}
														className="submit-loan-application"
														sx={{
															gap: '8px', minWidth: '150px', '&.Mui-disabled': {
																borderRadius: '8px',
																borderTopLeftRadius: '0',
																borderBottomLeftRadius: '0',
															}
														}}
														onClick={(event) => {
															event.stopPropagation()
															saveForm()
														}}
													>
														<Save/> {t('Save')}
														
														<span className="popover-submit">
														{t('Temporary saving of the application data')}
													</span>
													
													</Button>
												
												</ButtonGroup>
											
											</>
										}
										<ButtonGroup variant="outlined" aria-label="Basic button group" sx={{
											marginLeft: { xs: 'auto', sm: 'auto' }
										}}
										>
											<Button
												disabled={loading}
												size={"small"}
												variant={"contained"}
												sx={{
													marginLeft: { xs: '8px', sm: '8px', md: '20px', lg: '20px' },
													minWidth: '150px',
													boxShadow: 'none',
													'&.Mui-disabled': {
														borderRadius: '8px',
														borderTopLeftRadius: '0',
														borderBottomLeftRadius: '0',
													}
												}}
												onClick={(event) => {
													event.stopPropagation()
													saveForm(1)
												}}
											>
												<CheckSubmit/> {t('Submit')}
											</Button>
										</ButtonGroup>
									
									</Grid>
								</Grid>
							</div>
						</Grid>
					</Grid>
				</Box>
			</Box>
			<ContentLoader
				loading={loading}
				withBackDrop={true}
				useCircularLoader={true}
			/>
		</Box>
	);
};

export default withPermissionHOC(Index, ['access_loan_index']);
